/**
 * The message to show for a failed RTK Query call. `queryFulfilled` rejects with `{ error: { status, data } }`
 * while `.unwrap()` throws `{ status, data }`; the backend puts its text in `data.error` or `data.message`.
 * Reading only `error.data.error` from the first shape showed users the word "undefined" (SB-7554 review).
 */
export const apiErrorMessage = (error: any, fallback = "Something went wrong"): string => {
    const e = error?.error && typeof error.error === "object" ? error.error : error
    const data = e?.data
    const text =
        (typeof data?.error === "string" && data.error) ||
        (typeof data?.message === "string" && data.message) ||
        (typeof data === "string" && data) ||
        (typeof e?.error === "string" && e.error) ||
        (typeof error?.message === "string" && error.message)
    return text || fallback
}
